import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadFaqProducts } from '@/redux/actions/faq';
import { SUPPORT_HOST_AND_SERVERS_URL } from '@/config/urls/domainsUrls';
import FaqDefault from '../FaqDefault';


const FaqProducts = ({ className }) => {
  const faq = useSelector(state => state.faq);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadFaqProducts());
  }, [dispatch]);

  return (
    <FaqDefault
      questions={faq.products.questions}
      link={SUPPORT_HOST_AND_SERVERS_URL}
      className={className}
      loading={faq.loading}
    />
  );
};

export default FaqProducts;
